export default function registrationOnlyMode(): boolean {
  const registrationOnly = process.env.GATSBY_REGISTRATION_ONLY === "true";
  return registrationOnly;
}
